import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiBottomNavbarComponent } from './ui-bottom-navbar/ui-bottom-navbar.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, RouterModule, TranslateModule],
  declarations: [UiBottomNavbarComponent],
  exports: [UiBottomNavbarComponent],
})
export class SharedPartnerWebUiBottomNavbarModule {}
